<template>
  <Modal show class="shop-floorplans-dialog">
    <StepperComponent :value="steps" ref="stepper" state-handler="sessionStorage" :state-key="id" @submit="() => {}">
      <template #breadcrumb="{ item, index }">
        <button type="button" class="elder-stepper__breadcrumb-button">
          <span class="elder-stepper__breadcrumb-icon">
            {{ index + 1 }}
          </span>
          <span>{{ item.label }}</span>
        </button>
      </template>
      <template #navigation="{ meta, next, prev}">
        <template v-if="meta.active.id === 'overview'">
          <ButtonComponent :label="$t('close')" :icon="['fal', 'times']" @click="$emit('close')" />
          <ButtonComponent
            :label="$t('create')"
            theme="primary"
            :icon="['fal', 'plus']"
            style="margin-left: auto;"
            @click="add"
          />
        </template>
        <ButtonComponent
          v-if="meta.prev"
          :label="$t('prev')"
          type="submit"
          :icon="['fal', 'angle-left']"
          icon-placement="left"
          style="margin-left: auto;"
          @click="prev"
        />
        <ButtonComponent
          v-if="meta.next && !['overview'].includes(meta.active.id)"
          :label="$t('next')"
          type="submit"
          :icon="['fal', 'angle-right']"
          @click="next"
        />
        <ButtonComponent
          v-if="!meta.next"
          :label="$t('complete')"
          :success-label="$t('completed')"
          :loading-label="$t('saving')"
          :icon="['fal', 'arrow-to-right']"
          theme="success"
          type="button"
          @click="complete"
        />
      </template>
    </StepperComponent>
  </Modal>
</template>

<script>
import Model from '@/models/Shop/floorplan'
import { ModalComponent as Modal } from 'vue-elder-modal'
import Card from '@/components/Card'
import { StepperComponent } from 'vue-elder-stepper'
import Steps from './Steps'

export default {
  props: {
    value: Array,
  },
  data() {
    return {
      selected: null,
      id: new Date().getTime().toString(),
    }
  },
  computed: {
    steps() {
      let props = {
        value: this.value,
        selected: this.selected,
      }

      let listeners = {
        'update:selected': v => (this.selected = v),
        input: v => this.$emit('input', v),
        remove: v => {
          this.$emit(
            'input',
            this.value.filter(vi => vi !== v),
          )
          this.$nextTick(() => {
            this.$refs.stepper.state.set('overview')
            this.selected = null
          })
        },
      }

      return Steps().map(raw => {
        const { icon, ...s } = raw
        // let errors = Object.keys(this.validator.errors.errors)
        // s.isValid = (s.fields || []).every(f => !errors.find(e => e.startsWith(f)))
        s.props = {
          ...(s.props || {}),
          ...props,
        }
        s.listeners = {
          ...(s.listeners || {}),
          ...listeners,
        }
        return s
      })
    },
  },
  methods: {
    complete() {
      this.$refs.stepper.state.set('overview')
      this.selected = null
    },
    add() {
      let item = Model()
      this.$refs.stepper.state.set('basis')
      this.$emit('input', [...(this.value || []), item])
      this.selected = item
    },
  },
  components: {
    Modal,
    Card,
    StepperComponent,
  },
}
</script>

<style lang="scss">
.shop-floorplans-dialog {
  .elder-stepper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .elder-stepper__breadcrumb-button {
      pointer-events: none;
    }

    &__component {
      width: inherit;
    }
  }

  .elder-stepper__breadcrumbs {
    background-color: transparent;
    color: white;
  }

  .elder-stepper__breadcrumb-button {
    color: inherit !important;

    span:last-child {
      filter: drop-shadow(0 2px 2px black);
    }

    .elder-stepper__breadcrumb--active & {
      color: inherit;
    }
  }

  .elder-stepper__breadcrumb-arrow {
    opacity: 0.7;
  }

  .elder-stepper__breadcrumb-icon:before {
    border: 1px solid rgba(white, 0.3);
  }
}
</style>
